module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAUCAMAAABRYFY8AAAAAXNSR0IB2cksfwAAAIRQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/KpusAAAACx0Uk5TAENQybxPXNavNrDVW2njoykqpOFndvCWHB6Y7XMPt/2JEoz5bw6ybpL6hIfuGvrMAAAAjElEQVR4nL2R1xKCMBBFFyHSVYp0pBf1///PSIAU8sx5SHbu7JxkEwCKooCEi6ppKhLTq26YAKZlO2zq3u4PUnl+EG7pM4oT2pNmeYG38lXVJe9s2q6HYezaRpJjijxLDx7MBGHge8y5S/f8/uDVsS16z+/fM69+tM8l+sk7nOcH0c/A+TmQ9F+on/ADGj8OJnTy+kwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/geo-layers.png
// module id = 830
// module chunks = 0